import {
    REVOKE_PROXIES,
    REVOKE_PROXIES_SUCCESS,
    REVOKE_PROXIES_FAILURE,
} from 'src/pages/more/pages/proxies/redux/action/actionTypes.js';

const initialState = {
    loading: false,
    statusMessage: '',
    statusCode: '',
};

const RevokeProxyReducer = (state = initialState, action) => {
    // console.log(action, 'reducerRevoke');
    switch (action.type) {
        case REVOKE_PROXIES:
            return {
                ...state,
                loading: true,
                statusCode: '',
            };
        case REVOKE_PROXIES_SUCCESS:
            return {
                ...state,
                loading: false,
                statusMessage: action.payload.statusMessage,
                statusCode: action.payload.statusCode,
            };
        case REVOKE_PROXIES_FAILURE:
            return {
                ...state,
                loading: false,
            };
        default: {
            return { ...state };
        }
    }
};

export default RevokeProxyReducer;
